var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIconSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.51247 5.87868C7.27236 5.27839 6.69096 4.88477 6.04442 4.88477H3.86975C3.04247 4.88477 2.37183 5.55525 2.37183 6.38252C2.37183 13.4144 8.07245 19.115 15.1043 19.115C15.9316 19.115 16.6021 18.4443 16.6021 17.617L16.6024 15.442C16.6024 14.7955 16.2089 14.2142 15.6086 13.974L13.5243 13.1406C12.9851 12.9249 12.3712 13.022 11.925 13.3938L11.3871 13.8425C10.7589 14.366 9.83451 14.3243 9.25626 13.7461L7.74155 12.23C7.1633 11.6517 7.12057 10.7281 7.64409 10.0999L8.09265 9.56201C8.46444 9.11586 8.56237 8.50175 8.34668 7.96252L7.51247 5.87868Z",
    stroke: "#A0A0A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconSvg);
export default __webpack_public_path__ + "static/media/phoneIconSVG.dd4f32201ef71ec6b55f818d2a8c7dca.svg";
export { ForwardRef as ReactComponent };